
import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { IOrganization, IOrganizationRequest, IOrganizationResponse } from '../dashboard/organization/OrganizationList';
// import { IOrganization, IOrganizationRequest, IOrganizationResponse } from "@ontime/types";

const API_URL = ApiURL() + '/organizations';

class OrganizationService {

    async GetUserOrganizationsList(showDeleted: boolean = false): Promise<IOrganizationResponse[]> {
        return axios.get<IOrganizationResponse[]>(API_URL, {
            headers: AuthHeader(),
            params: { showDeleted }
        }).then(response => {
            return response.data;
        });
    }

    async CreateOrganization(input: IOrganizationRequest): Promise<IOrganizationResponse> {
        return axios.post<IOrganizationResponse>(API_URL, input, {
            headers: AuthHeader()
        }).then(response => {
            return response.data;
        });
    }

    async UpdateOrganization(organizationId: string, input: IOrganizationRequest): Promise<IOrganization> {
        return axios.put<IOrganization>(API_URL + `/${organizationId}`, input, {
            headers: AuthHeader()
        }).then(response => {
            return response.data;
        });
    }

    async GetOrganization(organizationId: string): Promise<IOrganization> {
        const response = await axios.get<IOrganization>(API_URL + `/${organizationId}`, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async DeactivateOrganization(organizationId: string): Promise<{ organizationId: string }> {
        return axios.put<{ organizationId: string }>(API_URL + `/${organizationId}/deactivate`, null, {
            headers: AuthHeader()
        }).then(response => {
            return response.data;
        });
    }

    async ActivateOrganization(organizationId: string): Promise<{ organizationId: string }> {
        return axios.put<{ organizationId: string }>(API_URL + `/${organizationId}/Activate`, null, {
            headers: AuthHeader()
        }).then(response => {
            return response.data;
        });
    }

    async DeleteOrganization(organizationId: string): Promise<{ organizationId: string }> {
        return await axios.delete<{ organizationId: string }>(API_URL + `/${organizationId}`, {
            headers: AuthHeader(),
        }).then(response => {
            return response.data;
        });
    }

}

export default new OrganizationService();